/* eslint-disable */
import { useState } from "react";
import { UserRound, CarFront } from "lucide-react";
import { TEAL, BG, WHITE, TEXT, SUB, LIGHT, LAYOUT_MAX_W } from "./components";
import Passenger from "./Passenger";
import Driver from "./Driver";

/** 底部「乘客／車主」切換列高度（與 BottomNav 疊放時用） */
export const UNIFIED_ROLE_BAR_H = 52;

export default function UnifiedPortal({ onBack, initialRole = "passenger", onOpenCommunity }) {
  const [role, setRole] = useState(initialRole === "driver" ? "driver" : "passenger");
  const lift = UNIFIED_ROLE_BAR_H;

  const tabBtn = (active) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    padding: "8px 6px 6px",
    border: "none",
    background: active ? TEAL + "14" : "transparent",
    cursor: "pointer",
    color: active ? TEAL : SUB,
    fontWeight: active ? 800 : 600,
    fontSize: 14,
    lineHeight: 1.2,
  });

  return (
    <div style={{ minHeight: "100vh", background: BG, position: "relative" }}>
      {role === "passenger" ? (
        <Passenger onBack={onBack} bottomNavLift={lift} onOpenCommunity={onOpenCommunity} />
      ) : (
        <Driver onBack={onBack} bottomNavLift={lift} />
      )}

      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 200,
          maxWidth: LAYOUT_MAX_W,
          margin: "0 auto",
          minHeight: UNIFIED_ROLE_BAR_H,
          background: WHITE,
          borderTop: `1px solid ${LIGHT}`,
          boxShadow: "0 -3px 14px rgba(0,0,0,0.08)",
          display: "flex",
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        <button type="button" style={tabBtn(role === "passenger")} onClick={() => setRole("passenger")}>
          <UserRound size={24} strokeWidth={2.25} color={role === "passenger" ? TEAL : SUB} aria-hidden />
          我係乘客
        </button>
        <button type="button" style={tabBtn(role === "driver")} onClick={() => setRole("driver")}>
          <CarFront size={24} strokeWidth={2.25} color={role === "driver" ? TEAL : SUB} aria-hidden />
          我係車主
        </button>
      </div>
    </div>
  );
}
